const DATABASE = 'bpl_operation'
function openDatabase(storeName) {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(storeName);
    request.onupgradeneeded = function (event) {
      const db = event.target.result;

      if (!db.objectStoreNames.contains(storeName)) {
        db.createObjectStore(storeName, { keyPath: 'objectSeq' });
        console.log('object store created');
      };
    }

    request.onsuccess = function (event) {
      const db = event.target.result;
      if (!db.objectStoreNames.contains(storeName)) {
        db.close();

        const newVersion = db.version + 1;
        upgradeDatabase(newVersion, storeName).then(resolve).catch(reject);
      } else {
        resolve(db);
      }
    };

    request.onerror = function (event) {
      reject(event.target.errorCode);
    };

  });
}

function upgradeDatabase(newVersion, storeName) {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DATABASE, newVersion);

    request.onupgradeneeded = function (event) {
      const db = event.target.result;

      if (!db.objectStoreNames.contains(storeName)) {
        db.createObjectStore(storeName, { keyPath: 'objectSeq' });
        console.log('New object store created in upgraded version');
      }
    };

    request.onsuccess = function (event) {
      const db = event.target.result;

      resolve(db);
    };

    request.onerror = function (event) {
      reject(event.target.errorCode);
    };
  });
}

function deleteDatabase(storeName) {
    indexedDB.deleteDatabase(storeName);
}

function addStore(storeName, data, truncate = false) {
  openDatabase(storeName)
    .then(function (db) {
      let transaction = db.transaction([storeName], 'readwrite')
      let store = transaction.objectStore(storeName);

      if (truncate) {
        store.clear();
      }
      data?.forEach(function (i, index) {
        store.add({ ...i, objectSeq: index })
      })

      transaction.onsuccess = function (e) {
        console.log("All Data has saved")
      }
      transaction.onerror = function (e) {
        console.error("Data Save failed", e)
      }
    })
}

function truncateStore(storeName) {
  openDatabase(storeName)
    .then(function (db) {
      let transaction = db.transaction([storeName], 'readwrite')
      transaction.objectStore(storeName).clear();

      transaction.onsuccess = function (e) {
        console.log("All Data has cleared")
      }
      transaction.onerror = function (e) {
        console.error("Data cleared failed", e)
      }
    })
}

function selectAll(storeName) {
  return new Promise((resolve, reject) => {
    openDatabase(storeName)
      .then(function (db) {
        let transaction = db.transaction([storeName], 'readwrite')
        transaction.objectStore(storeName).getAll().onsuccess = function(e) {
          resolve(e.target.result);
        }
        transaction.onsuccess = function (e) {
          console.log("All Data has cleared")
        }
        transaction.onerror = function (e) {
          reject(e)
        }
      })
  })
}

async function calculateIndexDBSize(storeName) {
    return new Promise((resolve, reject) => {
        const request = indexedDB.open(storeName,1);
        request.onsuccess = (event) => {
            const db = event.target.result;
            console.log(db)
            let totalSize = 0;
            console.log(db.transaction(db.name))
            const transaction = db.transaction(db.name, 'readonly')
            transaction.oncomplete = () => {
                resolve(totalSize);
            }
            transaction.onerror = (e) => {
                reject(e)
            }
            Array.from(db.objectStoreNames).forEach((storeName) => {
                const objectStore = transaction.objectStore(storeName);
                const storeRequest = objectStore.getAll();
                storeRequest.onsuccess = (e) => {
                    const records = e.target.result;
                    console.log("records", records);
                    records.forEach((record) => {
                        totalSize += JSON.stringify(record).length;
                    });
                };
                storeRequest.onerror = (e) => {
                    reject(e);
                };
            });

        }
        request.onerror = (e) => {
            reject(e);
        }
    })
}

function deleteAllDatabase() {
    indexedDB.databases().then((databases) => {
        databases.forEach((dbInfo) => {
            let request = indexedDB.deleteDatabase(dbInfo.name);

            request.onsuccess = function() {
                console.log(`Database ${dbInfo.name} deleted successfully`);
            };

            request.onerror = function() {
                console.log(`Error deleting database ${dbInfo.name}`);
            };

            request.onblocked = function() {
                console.log(`Database deletion blocked for ${dbInfo.name}`);
            };
        });
    });
}

// function deleteAllDatabase() {
//     return indexedDB.databases().then((databases) => {
//         let deletePromises = databases.map((dbInfo) => {
//             return new Promise((resolve, reject) => {
//                 let request = indexedDB.deleteDatabase(dbInfo.name);
//
//                 request.onsuccess = function() {
//                     console.log(`Database ${dbInfo.name} deleted successfully`);
//                     resolve();
//                 };
//
//                 request.onerror = function() {
//                     console.log(`Error deleting database ${dbInfo.name}`);
//                     reject();
//                 };
//
//                 request.onblocked = function() {
//                     console.log(`Database deletion blocked for ${dbInfo.name}`);
//                     reject();
//                 };
//             });
//         });
//
//         return Promise.all(deletePromises).then(() => {
//             console.log("All databases deleted successfully.");
//             window.alert("All databases deleted successfully.")
//         }).catch(() => {
//             console.log("Failed to delete some databases.");
//             window.alert("Failed to delete some databases.")
//         });
//     });
// }

export default openDatabase;
export { deleteDatabase, addStore, truncateStore, selectAll, calculateIndexDBSize, deleteAllDatabase }
